export const HANDOVER_ACTION_TYPES = {
	SET_HANDOVER_APARTMENT: "SET_HANDOVER_APARTMENT",
	SET_HANDOVER_TYPE: "SET_HANDOVER_TYPE",
	SET_HANDOVER_PROCESS: "SET_HANDOVER_PROCESS",
	CLEAR_HANDOVER: "CLEAR_HANDOVER"
} as const;

export const HANDOVER_MUTATION_TYPES = {
	SET_HANDOVER_APARTMENT: "SET_HANDOVER_APARTMENT",
	SET_HANDOVER_TYPE: "SET_HANDOVER_TYPE",
	SET_HANDOVER_PROCESS: "SET_HANDOVER_PROCESS",
	SET_LOADING: "SET_LOADING",
	SET_ERROR: "SET_ERROR",
	CLEAR_ERROR: "CLEAR_ERROR",
	SET_HANDOVER_ID: "SET_HANDOVER_ID",
	UPDATE_HANDOVER_NOTES: "UPDATE_HANDOVER_NOTES",
	UPDATE_HANDOVER_BUSINESS_TYPE: "UPDATE_HANDOVER_BUSINESS_TYPE",
	UPDATE_HANDOVER_BUSINESS_LEGAL_NAME: "UPDATE_HANDOVER_BUSINESS_LEGAL_NAME",
	UPDATE_HANDOVER_BUSINESS_TRADING_NAME: "UPDATE_HANDOVER_BUSINESS_TRADING_NAME",
	UPDATE_HANDOVER_BUSINESS_IDENTIFICATION: "UPDATE_HANDOVER_BUSINESS_IDENTIFICATION",
	UPDATE_HANDOVER_BILLING_FIRST_NAME: "UPDATE_HANDOVER_BILLING_FIRST_NAME",
	UPDATE_HANDOVER_BILLING_LAST_NAME: "UPDATE_HANDOVER_BILLING_LAST_NAME",
	UPDATE_HANDOVER_BILLING_IBAN: "UPDATE_HANDOVER_BILLING_IBAN",
	UPDATE_HANDOVER_BILLING_ADDRESS_DATA: "UPDATE_HANDOVER_BILLING_ADDRESS_DATA",
	UPDATE_HANDOVER_CUSTOMER_DATA: "UPDATE_HANDOVER_CUSTOMER_DATA",
	UPDATE_HANDOVER_CUSTOMER_IDENTIFICATION: "UPDATE_HANDOVER_CUSTOMER_IDENTIFICATION",
	CLEAR_HANDOVER: "CLEAR_HANDOVER"
} as const;
